





























import _ from 'lodash'
import { Vue, Component } from 'vue-property-decorator'
import { Action, Mutation, State } from 'vuex-class'
import { DropdownOption } from '@/components/common/VDropdown.vue'
import { Stencil, StencilSet } from '@/store/editor/types'
import { RootState } from '@/store/types'
import { setPageTitle } from '@/util/Helpers'
import { EDITOR_SET_SCHEMA, EDITOR_CLEAR } from '@/store/editor/constants'

@Component({ name: 'blank-editor' })
export default class BlankEditor extends Vue {
    /**
     * Entry schema stencils
     */
    @State((state: RootState) => state.editor.stencils)
    stencils!: StencilSet

    /**
     * Clear the editor
     */
    @Mutation(EDITOR_CLEAR)
    clearEditor!: () => void

    /**
     * Set the editor schema
     */
    @Mutation(EDITOR_SET_SCHEMA)
    setSchema!: (value: string) => void

    mounted(): void {
        setPageTitle('Home')
    }

    /**
     * Schema options for the dropdown
     */
    get schemas(): DropdownOption[] {
        return _.map(this.stencils, (value: Stencil, key: string) => ({
            name: value.title,
            value: key,
            icon: value.defaultIcon
        }))
    }

    newEntry(value: string): void {
        this.clearEditor()
        this.setSchema(value)
    }
}
